import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'

/** Samodzielny pager dla widoków, które nie mieszczą się w `DataTable`. Nic nie renderuje przy jednej stronie. */
export function Pager({
  page,
  count,
  pageSize,
  onPageChange,
  className = 'px-5 py-3',
}: {
  page: number
  count: number
  pageSize: number
  onPageChange: (page: number) => void
  className?: string
}) {
  const totalPages = Math.max(1, Math.ceil(count / pageSize))
  if (totalPages <= 1) return null
  return (
    <div
      className={`flex items-center justify-end gap-2 text-sm text-muted-foreground ${className}`}
    >
      <Button
        variant="outline"
        size="icon-sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        title="Poprzednia strona"
      >
        <ChevronLeft />
      </Button>
      <span className="tabular-nums">
        {page} / {totalPages}
      </span>
      <Button
        variant="outline"
        size="icon-sm"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        title="Następna strona"
      >
        <ChevronRight />
      </Button>
    </div>
  )
}
